// src/components/ProtectedRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { authTokens } = useAuth();

  if (!authTokens) {
    return <Navigate to="/login" />;
  }

  return children;
};

export default ProtectedRoute;
